import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, Grid, Typography } from '@mui/material';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { PmiButton } from 'shell/components/shared/button';
import { memo, useState } from 'react';
import Form from './form';
import { ModalDomesticVM } from '..';
import { FormikProps } from 'formik';

interface AccordionFilterProps {
  onSearch: () => void;
  formContext: FormikProps<ModalDomesticVM>;
}

const AccordionFilterComponent = ({
  onSearch,
  formContext,
}: AccordionFilterProps): React.ReactElement => {
  const [open, setOpen] = useState<boolean>(true);

  return (
    <Accordion expanded={open} onChange={() => setOpen(!open)}>
      <AccordionSummary
        aria-controls="panel-filter-content"
        id="panel-filter-content"
        expandIcon={<ExpandMore />}
      >
        <Typography>Filtri</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Form formContext={formContext} />
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <PmiButton variant="outlined" fullWidth color="cdmBrandThird" onClick={onSearch}>
              Cerca
            </PmiButton>
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};

AccordionFilterComponent.displayName = 'Accordion Filter component';

const AccordionFilter = memo(AccordionFilterComponent);

export default AccordionFilter;
